import { defineComponent as _defineComponent } from 'vue'
import { Ref, reactive, ref } from 'vue';
import { useLoader } from '@/composables/loader';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput.vue';
import CButton from '@/components/shared/CButton';
import CCustomCheckbox from '@/components/shared/CCustomCheckbox.vue';
import CButtonGroup, { CButtonGroupItem } from '@/components/shared/CButtonGroup';
import { addTeamMember } from '@/api/team';
import { AccessMode, TeamMember } from '@/api/typings/team';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMemberModal',
  emits: ["member-created", "handle-permissions", "cancel"],
  setup(__props, { emit }: { emit: ({
    (event: 'member-created', value: TeamMember): void;
    (event: 'handle-permissions', value: TeamMember): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {



const accessTypes: CButtonGroupItem[] = [
    {
        label: 'Full access',
        value: AccessMode.FULL
    },
    {
        label: 'Restricted',
        value: AccessMode.RESTRICTED
    }
];

const { execLoadedFn } = useLoader();

const createFormRef: Ref<InstanceType<typeof ValidationObserver> | null> = ref(null);

const memberModel = reactive({
    name: '',
    email: '',
    accessType: AccessMode.FULL,
    manageIntegrations: false
});

const createMember = async (): Promise<void> => {
    try {
        const newMember = await addTeamMember(
            memberModel.name,
            memberModel.email,
            memberModel.accessType,
            memberModel.manageIntegrations
        );

        emit('member-created', newMember);
        if (memberModel.accessType == AccessMode.RESTRICTED) emit('handle-permissions', newMember);
    } catch (error) {
        console.error('Failed to invite user', error);
    }
};

const cancelHandler = () => emit('cancel');

return { __sfc: true,emit, accessTypes, execLoadedFn, createFormRef, memberModel, createMember, cancelHandler, ValidationProvider, ValidationObserver, CModal, CInput, CButton, CCustomCheckbox, CButtonGroup, AccessMode }
}

})